module.exports = {
  HostUrl: process.env.NEXT_PUBLIC_HOST_URL ?? 'https://paji-toolset.net',
  BackendUrl: process.env.BACKEND_URL ?? 'http://localhost:8000',
  GoogleTrackingCode: 'AW-1005370006',
}
